import { render, staticRenderFns } from "./base-table.vue?vue&type=template&id=dfa60bdc&scoped=true&"
import script from "./base-table.vue?vue&type=script&lang=js&"
export * from "./base-table.vue?vue&type=script&lang=js&"
import style0 from "./base-table.vue?vue&type=style&index=0&id=dfa60bdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa60bdc",
  null
  
)

component.options.__file = "base-table.vue"
export default component.exports